




























































import { getAgencies } from '@/api/Agency/agency.api'
import AutocompleteVue from '@/components/Autocomplete.vue'
import { filterMixin } from '@/utils/mixins/filterMixin'
import { getUsers } from '@/api/Users/users.api'
import UserListItem from '@/components/UserListItem.vue'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: AutocompleteVue,
    appUsersListItem: UserListItem,
    FlatFilter,
  },
  data: function() {
    return {
      getAgencies: getAgencies,
      getUsers: getUsers,
      services: this.$store.getters.profile.services.map((item: string) => ({
        text: this.$t(item),
        value: item,
      })),
      types: [
        'REMITTANCE_CREATE',
        'REMITTANCE_REFUND',
        'BALANCE_PAYMENT',
        'BALANCE_CHARGE',
      ].map(type => ({ text: this.$t(type), value: type })),
    }
  },
})
